export default "__VITE_ASSET__50203ce9__"